export const queryKeys = {
  answers: {
    all: ["answers"],
    list: (keySearch = "") => [...queryKeys.answers.all, "list", keySearch],
    detail: (id) => [...queryKeys.answers.all, "detail", id],
  },
  documents: {
    all: ["documents"],
    list: (keySearch = "") => [...queryKeys.documents.all, "list", keySearch],
    detail: (id) => [...queryKeys.documents.all, "detail", id],
  },
  users: {
    all: ["users"],
    list: (keySearch = "") => [...queryKeys.users.all, "list", keySearch],
    detail: (id) => [...queryKeys.users.all, "detail", id],
  },
  sliders: {
    all: ["sliders"],
    active: () => [...queryKeys.sliders.all, "active"],
    detail: (id) => [...queryKeys.sliders.all, "detail", id],
    collections: (keySearch = "") => [
      ...queryKeys.sliders.all,
      "collections",
      keySearch,
    ],
    byCollection: (collection) => [
      ...queryKeys.sliders.all,
      "collection",
      collection,
    ],
  },
  history: {
    all: ["history"],
    byUser: (userID) => [...queryKeys.history.all, "user", userID],
    highestByUser: (userID) => [...queryKeys.history.all, "highest", userID],
    profile: (userID) => [...queryKeys.history.all, "profile", userID],
    rankingByAnswer: (answerID) => [
      ...queryKeys.history.all,
      "ranking",
      answerID,
    ],
  },
  comments: {
    all: ["comments"],
    byAnswer: (answerID) => [...queryKeys.comments.all, "answer", answerID],
  },
  flashcards: {
    all: ["flashcards"],
    publicDecks: (keySearch = "") => [
      ...queryKeys.flashcards.all,
      "public-decks",
      keySearch,
    ],
    myDecks: (userID, keySearch = "") => [
      ...queryKeys.flashcards.all,
      "my-decks",
      userID,
      keySearch,
    ],
    deck: (deckID) => [...queryKeys.flashcards.all, "deck", deckID],
    cards: (deckID, userID = "") => [
      ...queryKeys.flashcards.all,
      "cards",
      deckID,
      userID,
    ],
    wordSuggestions: (keySearch = "") => [
      ...queryKeys.flashcards.all,
      "word-suggestions",
      keySearch,
    ],
    wordLookup: (word = "") => [
      ...queryKeys.flashcards.all,
      "word-lookup",
      word,
    ],
  },
};
